document.documentElement.classList.remove('no-js');
(function () {
  'use strict';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }

  /* ---------- Header: menú y buscador ---------- */
  function initHeader() {
    var btns = $$('#goda-page .g-icon-button[aria-controls]');
    function closeAll(except) {
      btns.forEach(function (b) {
        if (b === except) return;
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p && !p.hidden) { p.hidden = true; b.setAttribute('aria-expanded', 'false'); }
      });
    }
    btns.forEach(function (b) {
      on(b, 'click', function (e) {
        e.stopPropagation();
        var p = document.getElementById(b.getAttribute('aria-controls')); if (!p) return;
        closeAll(b);
        var open = p.hidden; p.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = p.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 30); }
      });
    });
    on(document, 'click', function (e) {
      if (e.target.closest && (e.target.closest('.g-drawer') && !e.target.closest('a'))) return;
      closeAll(null);
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    $$('[data-vtx-gallery]').forEach(function (g) {
      var thumbs = $$('[data-vtx-thumb]', g), wraps = $$('.shop-image-zoom-wrapper', g), dots = $$('[data-vtx-dot]', g);
      var n = wraps.length, cur = 0; if (!n) return;
      function go(i) {
        i = (i + n) % n; if (i === cur && wraps[i].classList.contains('active')) return; cur = i;
        wraps.forEach(function (w, k) { var a = k === i; w.classList.toggle('active', a); var im = w.querySelector('.shop-main-image'); if (im) im.classList.toggle('active', a); });
        thumbs.forEach(function (t, k) { t.classList.toggle('active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
        var t = thumbs[i], box = t && t.parentNode;
        if (t && box && box.scrollTo) {
          var vertical = box.scrollHeight > box.clientHeight + 4;
          if (vertical) box.scrollTo({ top: t.offsetTop - box.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
          else box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { on(t, 'click', function () { go(k); }); });
      dots.forEach(function (d, k) { on(d, 'click', function () { go(k); }); });
      $$('[data-vtx-prev]', g).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); go(cur - 1); }); });
      $$('[data-vtx-next]', g).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); go(cur + 1); }); });
      var box = g.querySelector('.shop-image-container'), x0 = null, y0 = null;
      on(box, 'touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      on(box, 'touchend', function (e) {
        if (x0 === null) return; var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });
  }

  /* ---------- Desplegables del producto ---------- */
  function initProductFaq() {
    $$('[data-vtx-faq]').forEach(function (q) {
      on(q, 'click', function () {
        var a = document.getElementById(q.getAttribute('aria-controls')); if (!a) return;
        var open = q.getAttribute('aria-expanded') !== 'true';
        q.setAttribute('aria-expanded', open ? 'true' : 'false'); a.setAttribute('aria-hidden', open ? 'false' : 'true');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px'; a.style.opacity = open ? '1' : '0';
        var tg = q.querySelector('.faq-toggle'); if (tg) tg.style.transform = open ? 'rotate(45deg)' : '';
      });
    });
  }

  /* ---------- Preguntas frecuentes ---------- */
  function initStoreFaq() {
    $$('[data-vtx-sfaq]').forEach(function (q) {
      function toggle() {
        var a = q.nextElementSibling; if (!a) return;
        var open = q.getAttribute('aria-expanded') !== 'true';
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.setProperty('max-height', open ? (a.scrollHeight + 40) + 'px' : '0px', 'important');
        a.style.setProperty('padding-top', open ? 'var(--answer-padding-top,15px)' : '0px', 'important');
        a.style.setProperty('padding-bottom', open ? 'var(--answer-padding-bottom,15px)' : '0px', 'important');
        var tg = q.querySelector('.store-faq-toggle'); if (tg) tg.style.transform = open ? 'rotate(45deg)' : '';
      }
      on(q, 'click', toggle);
      on(q, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------- Carruseles con flechas ---------- */
  function initCarousels() {
    $$('[data-vtx-carousel]').forEach(function (s) {
      var track = s.querySelector('.g-carousel'); if (!track) return;
      function step(dir) {
        var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 15 : track.clientWidth * 0.8;
        var max = track.scrollWidth - track.clientWidth;
        var to = track.scrollLeft + dir * w;
        if (to > max + 2) to = 0; else if (to < -2) to = max;
        track.scrollTo({ left: to, behavior: 'smooth' });
      }
      $$('[data-vtx-prev]', s).forEach(function (b) { on(b, 'click', function () { step(-1); }); });
      $$('[data-vtx-next]', s).forEach(function (b) { on(b, 'click', function () { step(1); }); });
    });
  }

  /* ---------- Reseñas: mosaico + ver más ---------- */
  function initReviews() {
    $$('[data-vtx-reviews]').forEach(function (s) {
      var grid = s.querySelector('.gx-masonry'), more = s.querySelector('[data-vtx-more]'); if (!grid) return;
      var lastW = -1, lastSig = '';
      function layout() {
        var W = grid.clientWidth; if (!W) return;
        var items = $$('.gx-real-review', grid).filter(function (a) { return !a.hidden; });
        var sig = W + ':' + items.length; if (sig === lastSig) return; lastSig = sig;
        var cols = W >= 750 ? 4 : 2, gap = 10, cw = (W - gap * (cols - 1)) / cols, hs = [];
        for (var c = 0; c < cols; c++) hs.push(0);
        items.forEach(function (a) { a.style.position = 'absolute'; a.style.width = cw + 'px'; });
        items.forEach(function (a) {
          var c = hs.indexOf(Math.min.apply(null, hs));
          a.style.left = (c * (cw + gap)) + 'px'; a.style.top = hs[c] + 'px';
          hs[c] += a.offsetHeight + gap;
        });
        grid.style.height = Math.max.apply(null, hs) + 'px'; grid.classList.add('is-laid-out');
      }
      $$('img', grid).forEach(function (im) { if (!im.complete) on(im, 'load', function () { lastSig = ''; layout(); }); });
      var t = null; on(window, 'resize', function () { clearTimeout(t); t = setTimeout(function () { if (grid.clientWidth !== lastW) { lastW = grid.clientWidth; lastSig = ''; layout(); } }, 150); });
      function refreshMore() { if (more) more.hidden = !$$('.gx-real-review[hidden]', grid).length; }
      on(more, 'click', function () {
        $$('.gx-real-review[hidden]', grid).slice(0, 10).forEach(function (a) { a.hidden = false; var im = a.querySelector('img'); if (im && !im.complete) on(im, 'load', function () { lastSig = ''; layout(); }); });
        lastSig = ''; layout(); refreshMore();
      });
      refreshMore(); layout();
    });
  }

  /* ---------- Botón de compra → Releasit del usuario ---------- */
  var RSI = '._rsi-buy-now-button, #rsi_buy_now_button, [id^="_rsi-buy-now-button"]:not(#_rsi-buy-now-button-floating)';
  function realRsi() {
    var list = $$(RSI);
    for (var i = 0; i < list.length; i++) { if (!list[i].closest('[data-vtx-buy]') && !list[i].closest('#_rsi-buy-now-button-floating')) return list[i]; }
    return null;
  }
  function buy() {
    var b = realRsi(); if (b) { b.click(); return; }
    var hook = document.querySelector('[data-vtx-rsi] a[href="/rsi-btn-hook"]');
    var f = document.querySelector('[data-vtx-form]');
    if (f) { f.submit(); return; }
    if (hook) window.location.href = '/cart';
  }
  function initBuy() {
    $$('[data-vtx-buy]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); buy(); });
      on(b, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); buy(); } });
    });
    $$('a[href="#goda-producto"]').forEach(function (a) {
      on(a, 'click', function (e) { var t = document.querySelector('[data-vtx-gallery]'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }

  function init() {
    [initHeader, initGallery, initProductFaq, initStoreFaq, initCarousels, initReviews, initBuy].forEach(function (f) {
      try { f(); } catch (e) { if (window.console) console.warn('vtx', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
